import styled, { keyframes } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import StarsRating from '../../assets/icons/star.svg';

const StarsContainer = styled.div`
  width: ${({ width }) => width || '100%'};
  display: flex;
  justify-content: space-between;
`;

const bgColorAnimation = keyframes`
0% { opacity:0};
100% { opacity: 1};
`;

const ContainerInsideStar = styled.div`
  height: ${({ height }) => height || '20px'};
  width: ${({ width }) => width || '20px'};
  background-color: ${({ color, showInsideStar }) =>
    showInsideStar ? select(color || 'neutralDarkGray') : 'transparent'};
  position: relative;
  display: flex;
  z-index: 1;
  overflow: hidden;
  opacity: 1;
  animation: ${({ showInsideStar }) => (showInsideStar ? bgColorAnimation : 'none')} 3s ease-in-out;

  /* Evitar bordes y sombras */
  border: none;
  outline: none;
  box-shadow: none;
  background-clip: padding-box; /* Evitar que se muestre el borde */
`;

const Star = styled.img`
  height: ${({ height }) => height || '20px'};
  width: ${({ width }) => width || '21px'};
  background-image: ${({ icon }) => `url(${icon || StarsRating})`};
  background-position: center;
  background-size: cover;
  background-color: transparent;
  z-index: 3;

  /* Eliminar bordes o sombras */
  border-top: 1px ${select('white')} solid;
  outline: none !important;
  box-shadow: none;

  /* Mejora del renderizado */
  image-rendering: optimizeQuality;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
`;

const InsideStar = styled.div`
  height: ${({ height }) => height || '20px'};
  width: ${({ fill }) => `${fill}%` || '0%'};
  background-color: ${({ color }) => select(color || 'yellow')};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  /* Evitar artefactos visuales */
  border: none;
  outline: none;
  box-shadow: none;
  overflow: hidden;
`;

export { StarsContainer, Star, ContainerInsideStar, InsideStar };
